/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_ClockChannelDto } from '../models/BigClock_Api_Models_ClockChannelDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MechanismsService {
    /**
     * @param clockStationId
     * @param channel
     * @returns any Success
     * @throws ApiError
     */
    public static getApiMechanismsChannel(
        clockStationId: string,
        channel: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/Mechanisms/{clockStationId}/channel/{channel}',
            path: {
                'clockStationId': clockStationId,
                'channel': channel,
            },
        });
    }
    /**
     * @param clockStationId
     * @param channel
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static putApiMechanismsChannel(
        clockStationId: string,
        channel: number,
        requestBody?: BigClock_Api_Models_ClockChannelDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/Mechanisms/{clockStationId}/channel/{channel}',
            path: {
                'clockStationId': clockStationId,
                'channel': channel,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
